import { useCallback } from 'react';
import * as amplitude from '@amplitude/analytics-browser';
import usePlatform from './usePlatform';
import { getEventSource } from '../shared/utils/general.util';
import { logger } from '../shared/utils/logger';

/**
 * Custom hook for tracking events in Amplitude Analytics
 *
 * @example
 * const { trackEvent } = useAmplitude();
 * trackEvent('Button Clicked', { button_name: 'purchase_plan' });
 */
const useAmplitude = () => {
	const { isMobile } = usePlatform();

	/**
	 * Track a custom event in Amplitude
	 * @param eventName - Name of the event to track
	 * @param eventProperties - Optional properties to attach to the event
	 */
	const trackEvent = useCallback(
		async (eventName: string, eventProperties?: Record<string, any>) => {
			try {
				const result = amplitude.track(eventName, {
					...eventProperties,
					source: getEventSource(isMobile),
				});
				await result.promise;
			} catch (error) {
				logger.error('Amplitude tracking error:', error);
			}
		},
		[isMobile],
	);

	return { trackEvent };
};

export default useAmplitude;
